export const MapTypeEnum = Object.freeze({
    roadmap: 'roadmap',
    raster: 'raster',
    satellite: 'satellite',
    map3d: 'map3d'
});